<div class="error-wrapper">
  <div class="not-found-page">
    <div class="not-found-page__image"></div>
    <div class="not-found-page__message">
      <div id="title" class="not-found-page__title">
        {{ 'notFound.title' | translate }}
      </div>
      <div id="message" class="not-found-page__text">
        {{ 'notFound.text' | translate }}
      </div>
      <gl-button color-primary [text]="'notFound.goHome' | translate" [routerLink]="['/']">
      </gl-button>
    </div>
    <div class="not-found-page__logo"></div>
  </div>
</div>
